import { HierarchyBackupService } from './../../service/hierarchy-backup.service';
import { UserNode } from './../../model/user-node';
import { SiteBuilder } from './../../model/builder/site.builder';
import { Site } from './../../model/site';
import { HierarchyService } from './../../service/hierarchy.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import 'rxjs/add/observable/combineLatest';
import {EmitterService} from '../../service/EmitterService';
import {SessionService} from '../../service/SessionService';
import { ActivatedRoute } from '@angular/router';
import { CoachingService } from '../../service/coaching.service';
import { UserService } from '../../service/UserService';
import { ROLE_MANAGER_QUALITE } from '../../model/commons/RoleConstants';
import {environment} from "../../../environments/environment";
import {AuthService} from "../../auth/services/auth.service";
import {RoleService} from "../../service/RoleService";

@Component({
  selector: 'app-hierarchy-tree',
  templateUrl: './hierarchy-tree.component.html',
  styleUrls: ['./hierarchy-tree.component.css']
})
export class HierarchyTreeComponent implements OnInit {

  @Output() activateHierarchyNode = new EventEmitter();
  nodes = [];
  sites: Site[] = [];
  options = {};
  usernameVerrou;

  constructor(private hierarchyService: HierarchyService,
              private hierarchyBackupService: HierarchyBackupService,
              private coachingService: CoachingService,
              private roleService: RoleService,
              private route: ActivatedRoute,
              private eventEmit: EmitterService,
              private session: SessionService,
              private user: UserService) { }

  ngOnInit() {
   this.buildTreeItems()
  }

  buildTreeItems() {
    this.route.data.subscribe(d => {
      this.route.queryParamMap.source.subscribe(result  => {
          this.usernameVerrou = result && result.usernameVerrou ? result.usernameVerrou : undefined;
      });
      switch(d.origin) {
        case 'coaching':
          this.buildCoachingNodes();
          break;
        default:
          this.usernameVerrou ? this.buildTimesheetNodes(this.usernameVerrou) : this.buildTimesheetNodes();
      }
    });
  }

  buildCoachingNodes() {
    this.coachingService.loadHierarchy().subscribe((sitesVO: any) => {
      sitesVO.forEach(siteVO => {
        this.sites.push(SiteBuilder.build(siteVO, true));
      });
      this.nodes = this.hierarchyService.buildTree(this.sites);
    }, error1 => {
      this.session.redirectBadRequest(error1);
    });
  }

  buildTimesheetNodes(usernameVerrou?) {
    const userRoles = Object.keys(this.user.getPermission()).indexOf(ROLE_MANAGER_QUALITE) > -1;
    if (userRoles) {
      if ((this.nodes && this.nodes.length === 0) || !this.nodes) {
        this.hierarchyService.getQualityTreeUsers().subscribe(sitesVO => {
            sitesVO.forEach(site => {
              this.sites.push(SiteBuilder.build(site, true));
            });
            this.nodes = usernameVerrou ? this.hierarchyService.buildTree(this.sites, null, usernameVerrou) : this.hierarchyService.buildTree(this.sites);
          },
          error1 => this.session.redirectBadRequest(error1));
      }
    } else {
      this.hierarchyService.loadHierarchy().subscribe(resp => {
        const sites: Array<any> = this.excludsOpsOfBum(resp)
        if(!environment.production) {
          localStorage.setItem("loadHierarchy", JSON.stringify(sites))
        }
        sites.forEach(s => {
          this.sites.push(SiteBuilder.build(s, true));
        });

        this.nodes = usernameVerrou ? this.hierarchyService.buildTree(this.sites, null, usernameVerrou) : this.hierarchyService.buildTree(this.sites);
      });
    }


  }

  excludsOpsOfBum(sites: Array<any>) {
    const hierarchy = this.roleService.isTL ? sites : sites.map((site) => {
      site.teams = site.teams.map((team) => {
        team.users = team.users.filter(e => e.profile != "COORDINATOR");
        return team;
      });

      site.sitelinkedusers = site.sitelinkedusers.filter((user) => {
        return user.profile != "COORDINATOR";
      });
      return site
    });
    return hierarchy;
  }

  buildQualityUserNameNode(user: any) {
    return user.firstName + ' ' + user.lastName + ' [' + user.registrationNumber + ']';
  }
  filter(query: string) {
    this.nodes = this.hierarchyService.buildTree(this.sites, query);
    // this.activateHierarchyNode.emit({});
  }
  public onActivate() {
    return (members: any) => {
      const eventArgs = {
        periods: null,
        agentName: null,
        teamName: null,
        siteName: null,
        members: [],
        villeLabel: null
      };
      members = members[0];
      eventArgs.periods   = (members && members.periods ? members.periods : [{start: null, end: null}] );
      eventArgs.members   = members && members.users;
      eventArgs.siteName  = members &&  members.siteName;
      eventArgs.teamName  = members && members.teamName;
      eventArgs.villeLabel= members && members.villeLabel;
      eventArgs.agentName = members && members.agentName;
      eventArgs.siteName  = (eventArgs.siteName === eventArgs.teamName ? '' : eventArgs.siteName);
      if (eventArgs.teamName !== null && eventArgs.siteName === '') {
        eventArgs.siteName = eventArgs.teamName;
        eventArgs.teamName = '';
      }
      this.eventEmit.emitChangeEvent(eventArgs);
    };
  }
  public o(el) {
  }

}

export interface HierarchyNodeSelectedEventArgs {
  periods: Array<any>;
  agentName: string;
  teamName: string;
  siteName: string;
  members: UserNode[];
}




// WEBPACK FOOTER //
// ./src/app/view/hierarchy-tree/hierarchy-tree.component.ts